import { useEffect } from 'react';
import { PropTypes } from 'prop-types';
import Preview, { preparePanoramaXML } from './SlovakianaPreviewService';
import '../../custom-one-use/CultureObjects/CultureObject.css';


PanoramaViewer.propTypes = {
    preview: PropTypes.any,
};

export default function PanoramaViewer({ preview }) {
    useEffect(() => {
        const viewer = document.getElementById("figure-renderer");
        if (viewer) {
            const presentationConfig = {
                container: viewer,
                localization: {
                    errorRenderingView: "Pre tento kultúrny objekt sa nepodarilo vytvoriť náhľad.",
                    loading: "Načítavam..."
                }
            };
            Preview.initialize({
                type: "sphericalPanorama",
                data: {
                    xmlData: preparePanoramaXML(preview)
                },
                contentId: preview.structDivId, // "CAIR_DIV_PANORAMA_1",
                contentDo: preview.nid // "urn:nbn:sk:cair-do3mi9z"
            },
            presentationConfig, true);
        }
    }, [preview]);

    return <figure
        id='figure-renderer'
        className='ko-detail-image-holder preview-box'
    />
}